import jwtDecode from 'jwt-decode'
import type { JwtPayload } from 'jwt-decode'
import type { AuthData } from './auth-data.js'

export interface DecodeParams {
  idToken: string
  accessToken: string
  /**
   * W2 (docs/SECURITY.md): the refresh token stays in an HttpOnly cookie and is
   * not delivered to the browser, so it is optional here — the auth-proxy
   * responses omit it entirely.
   */
  refreshToken?: string
  expiresIn: number
}

export const decodeOAuthData = ({ idToken, accessToken, refreshToken, expiresIn }: DecodeParams): AuthData => {
  const data: AuthData = {
    idToken: {
      jwtToken: idToken,
      payload: jwtDecode<JwtPayload>(idToken),
    },
    accessToken: {
      jwtToken: accessToken,
    },
    ...(refreshToken ? { refreshToken: { jwtToken: refreshToken } } : {}),
    expires: Date.now() + expiresIn * 1000,
  }

  return data
}
